const TotalStaffIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <g clipPath="url(#clip0_590_7304)">
        <path
          d="M39 48H9C4.029 48 0 43.971 0 39V9C0 4.029 4.029 0 9 0H39C43.971 0 48 4.029 48 9V39C48 43.971 43.971 48 39 48Z"
          fill="#E9EEFE"
        />
        <path
          d="M16.0005 24.375C17.1048 24.375 18 23.4798 18 22.3755C18 21.2712 17.1048 20.376 16.0005 20.376C14.8962 20.376 14.001 21.2712 14.001 22.3755C14.001 23.4798 14.8962 24.375 16.0005 24.375Z"
          fill="#183883"
        />
        <path
          d="M18.6705 25.774C17.661 26.5345 17.001 27.754 17.001 29.1235V29.374H12.75C12.3405 29.374 12 29.0335 12 28.624V28.1245C12 26.605 13.23 25.375 14.7495 25.375H17.25C17.7705 25.375 18.2595 25.525 18.6705 25.774Z"
          fill="#183883"
        />
        <path
          d="M31.9995 24.375C33.1038 24.375 33.999 23.4798 33.999 22.3755C33.999 21.2712 33.1038 20.376 31.9995 20.376C30.8952 20.376 30 21.2712 30 22.3755C30 23.4798 30.8952 24.375 31.9995 24.375Z"
          fill="#183883"
        />
        <path
          d="M36.0001 28.125V28.6245C36.0001 29.034 35.6596 29.3745 35.2501 29.3745H31.0006V29.124C31.0006 27.7545 30.3406 26.5335 29.3311 25.7745C29.7406 25.524 30.2311 25.374 30.7516 25.374H33.2521C34.7701 25.3755 36.0001 26.6055 36.0001 28.125Z"
          fill="#183883"
        />
        <path
          d="M24 24.874C25.6569 24.874 27 23.5309 27 21.874C27 20.2172 25.6569 18.874 24 18.874C22.3431 18.874 21 20.2172 21 21.874C21 23.5309 22.3431 24.874 24 24.874Z"
          fill="#718AD6"
        />
        <path
          d="M26.7495 26.374H21.249C19.7325 26.374 18.4995 27.607 18.4995 29.1235V30.6235C18.4995 31.0375 18.8355 31.3735 19.2495 31.3735H28.749C29.163 31.3735 29.499 31.0375 29.499 30.6235V29.1235C29.5005 27.6085 28.266 26.374 26.7495 26.374Z"
          fill="#718AD6"
        />
      </g>
      <defs>
        <clipPath id="clip0_590_7304">
          <path
            d="M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default TotalStaffIcon;
